// Single source of truth for backend URLs, mirroring sk-catalog-frontend's
// src/api/endpoints.ts structure. Two bases: the platform (identity/session)
// and drive's own product API.
export const PLATFORM_API_URL = process.env.SKPLATFORM_API_URL || 'http://localhost:3003';
export const DRIVE_API_URL = process.env.VITE_DRIVE_API_URL || 'http://localhost:3002';
export const PLATFORM_AUTH_URL = (process.env as any).PLATFORM_AUTH_URL || 'http://localhost:3000';

const P = `${PLATFORM_API_URL}/v1`;

export const Platform_Me_Url = `${P}/me`;
export const Platform_Logout_Url = `${P}/auth/logout`;
export const Platform_Refresh_Url = `${P}/auth/refresh`;
